import React from 'react';
import PropTypes from 'prop-types';
import {
  ResultsContainer,
  ResultWrapper,
  OptionCategory,
  SearchOption,
  SearchAbbrev,
} from './AdvancedSearchOptions.styles';

const SEARCH_INPUT_PADDING = 20;

const AdvancedSearchOptions = ({
  availableSearchOptions = [],
  onSearchTypeChange,
  closeDropdown,
}) => {
  const handleOnClick = searchType => {
    onSearchTypeChange(searchType);
    closeDropdown();
  };

  const maxWidth = document.documentElement.clientWidth - SEARCH_INPUT_PADDING; // ugly solution for making fixed width elements dynamic while resizing the screen
  return (
    <ResultsContainer maxWidth={maxWidth}>
      <OptionCategory>ADDITIONAL DATA SEARCH</OptionCategory>
      {availableSearchOptions.map((option, idx) => (
        <ResultWrapper
          p={10}
          key={idx}
          horizontal
          onClick={() => handleOnClick(option.prefix)}
        >
          <SearchOption>{option.name}</SearchOption>
          <SearchAbbrev>{option.prefix}</SearchAbbrev>
        </ResultWrapper>
      ))}
    </ResultsContainer>
  );
};

AdvancedSearchOptions.propTypes = {
  onSearchTypeChange: PropTypes.func.isRequired,
};

export default AdvancedSearchOptions;
